import FormSystemError from "../../../utils/form-error-constants";
import intlTelInput from 'intl-tel-input';
import module from "../../../module/common";

import { getCode } from "country-list";

import 'intl-tel-input/build/css/intlTelInput.css';

let intlEssence = null;

class Registration {
    init() {
        this.form = $('.checkoutForm #userInfoForm');
        this.formErrorConstants = new FormSystemError('.checkoutForm #userInfoForm');
        this.validatePassword();
        this.validatePhoneNumber();
        this.initCountryIntlPhoneInput();
    }

    validatePassword() {
        let self = this;
        this.form.on('submit', function (event) {
            $(this).find('[type="password"]').each(function () {
                if ($(this).val()) {
                    if (!self.checkPasswordInput($(this))) {
                        event.preventDefault();
                    }
                }
            })
        });
        this.form.find('[type="password"]').on('focusout', function () {
            self.checkPasswordInput($(this))
        });
    }

    checkPasswordInput(password) {
        if (!this.isPasswordStrong(password.val())) {
            password.attr('data-error', password.data('error-message'));
            this.formErrorConstants.init();
            return false
        }
        password.removeAttr('data-error');
        let el = password.closest('.column');
        this.formErrorConstants.hideNoticeErrorNext(el, el);
        el.addClass('valid');
        return true
    }

    isPasswordStrong(newPassword) {
        return /\d/.test(newPassword) && isNaN(newPassword) && /[a-zA-Z]/.test(newPassword) && newPassword.length >= 8;
    }

    validatePhoneNumber() {
        const formError = this.formErrorConstants;
        const currentForm = this.form;
        let isPassed;

        if (isPassed) return;

        this.form.on('submit', function (event) {
            $(this).find('.js_submit-btn').each(async function () {
                event.preventDefault();
 
                const $phoneInput = $('.js_phone-input');
                const phoneValue = $phoneInput.val();
                const countryTagFromIti = $('.iti__flag')?.attr('class')?.split(' ')[1]?.split('__')[1] || '';
                const countryTag = countryTagFromIti || module.fillWithCountryCode($('.js_country-input').val(), getCode);
                const countryCode = phoneValue.includes('+') ? '' : $('.iti__selected-dial-code').text() || '';
    
                if (phoneValue) {
                    const response = await $.get({
                        url: `${window.env.publicApiUrl}/validatePhoneNumber?phoneNumber=${phoneValue}&country=${countryTag}`
                    });
    
                    if (!response?.isValid) {
                        $phoneInput.attr('data-error', 'Incorrect phone number');
                        formError.init();
                    } else {
                        isPassed = true;
                        
                        $phoneInput.val(`${countryCode}${phoneValue}`);

                        $phoneInput.removeAttr('data-error');
                        currentForm.unbind("submit").submit();
                    }
                }
            })
        });
    }

    initCountryIntlPhoneInput(initialCountry) {        
        const $phone = document.querySelector('#phone');

        if (!$phone) return;

        const initializer = (countryCode) => {
            const input = intlTelInput($phone, {
                separateDialCode: true,
                initialCountry: initialCountry || countryCode || getCode(''),
                allowDropdown: false,
                autoPlaceholder: 'aggressive',
            });  

            intlEssence = input;
        }

        $('.js_country-input').on('change', event => {
            if (intlEssence) {
                intlEssence.destroy();
            }

            initializer(module.fillWithCountryCode($(event.currentTarget).val(), getCode));
        });

        initializer('nl');
   }
}

$(document).ready(function () {
    let registration = new Registration();
    registration.init();
});